import { Record as record } from 'immutable';

import { construct, fields } from '../../helpers/LinkMapper';
import { PaymentAuthStatuses, PaymentAuthCodes } from '../../constants/AppConstants';


const defaults = {
    id: null,
    status: null,
    code: null,
    redirect: null,
    md: null,
    pareq: null,
    message: null,
    threeDSServerTransId: null
};

// When these codes are given
// the user can proceed further
const ContinueCodes = [
    PaymentAuthCodes.ENROLLED,
    PaymentAuthCodes.OK,
    PaymentAuthCodes.PENDING,
    PaymentAuthCodes.FRAUD,
    PaymentAuthCodes.UNDER_REVIEW
];

class CocsResponse extends record(defaults) {

    static fromJSON (json = {}) {
        json.id = json.pid;
        return construct(CocsResponse, json, {
            id: fields.number,
            status: fields.string,
            code: fields.string,
            redirect: fields.string,
            md: fields.string,
            pareq: fields.string,
            message: fields.string,
            threeDSServerTransId: fields.string,
        });
    }

    isSuccess () {
        return ContinueCodes.includes(this.code);
    }

    isFraud () {
        return this.status === PaymentAuthStatuses.FRAUD;
    }

    isEnrolled () {
        return this.status === PaymentAuthStatuses.ENROLLED;
    }

    isError () {
        return this.status !== PaymentAuthStatuses.SUCCESS && !this.isFraud();
    }

    isProcessing() {
        return this.code === PaymentAuthCodes.PROCESSING;
    }

}


export default CocsResponse;



// WEBPACK FOOTER //
// ./src/records/payment/CocsResponse.js